import { render, staticRenderFns } from "./saas_electronic_shelf_list.vue?vue&type=template&id=a6ba4ec4&scoped=true"
import script from "./saas_electronic_shelf_list.vue?vue&type=script&lang=js"
export * from "./saas_electronic_shelf_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ba4ec4",
  null
  
)

export default component.exports